import Input from "./js/objects/forms/controls/input/input.js";
import Textarea from "./js/objects/forms/controls/textarea/textarea.js";
import Select from "./js/objects/forms/controls/select/select.js";
import Checkbox from "./js/objects/forms/controls/checkbox/checkbox.js";
import Radio from "./js/objects/forms/controls/radio/radio.js";

import Form from "./js/objects/forms/form/form.js";
import Conditional from "./js/utilities/conditional/conditional.js";

document.addEventListener("DOMContentLoaded", () => {
    const inputElements = Array.prototype.slice.call(
        document.querySelectorAll(".js-input")
    );
    inputElements.forEach((inputElement) => {
        let inputInstance = new Input();
        inputInstance.init(inputElement);
    });

    const checkboxElements = Array.prototype.slice.call(
        document.querySelectorAll(".js-checkbox")
    );
    checkboxElements.forEach((checkboxElement) => {
        let checkboxInstance = new Checkbox();
        checkboxInstance.init(checkboxElement);
    });

    const radioElements = Array.prototype.slice.call(
        document.querySelectorAll(".js-radio")
    );
    radioElements.forEach((radioElement) => {
        let radioInstance = new Radio();
        radioInstance.init(radioElement);
    });

    const textareaElements = Array.prototype.slice.call(
        document.querySelectorAll(".js-textarea")
    );
    textareaElements.forEach((textareaElement) => {
        let textareaInstance = new Textarea();
        textareaInstance.init(textareaElement);
    });

    const selectElements = Array.prototype.slice.call(
        document.querySelectorAll(".js-select")
    );
    selectElements.forEach((selectElement) => {
        let selectInstance = new Select();
        selectInstance.init(selectElement);
    });

    const formElements = Array.prototype.slice.call(
        document.querySelectorAll(".js-form")
    );
    formElements.forEach((formElement) => {
        let formInstance = new Form();
        formInstance.init(formElement);
    });

    const conditionalElements = Array.prototype.slice.call(
        document.querySelectorAll("[data-condition]")
    );
    conditionalElements.forEach((conditionalElement) => {
        let conditionInstance = new Conditional();
        conditionInstance.init(conditionalElement);
    });
});
